import { render } from "./inactivityPage.vue?vue&type=template&id=652e1c79&scoped=true"
import script from "./inactivityPage.vue?vue&type=script&lang=js"
export * from "./inactivityPage.vue?vue&type=script&lang=js"

import "./inactivityPage.vue?vue&type=style&index=0&id=652e1c79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652e1c79"]])

export default __exports__